/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { entitlementIndex } from '../../axios/entitlementIndex'
import type {
	EntitlementIndexError,
	EntitlementIndexPathParams,
	EntitlementIndexResponse,
} from '../../types/EntitlementIndex'

export const entitlementIndexQueryKey = (organisation: EntitlementIndexPathParams['organisation']) =>
	[{ url: '/:organisation/entitlements', params: { organisation } }] as const

export type EntitlementIndexQueryKey = ReturnType<typeof entitlementIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/EntitlementController.php EntitlementController::index */
export function entitlementIndexQueryOptions(
	organisation: EntitlementIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		EntitlementIndexResponse,
		AxiosError<EntitlementIndexError>,
		EntitlementIndexResponse,
		EntitlementIndexQueryKey
	>({
		queryKey: entitlementIndexQueryKey(organisation),
		queryFn: ({ signal }) => entitlementIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/EntitlementController.php EntitlementController::index */
export function useEntitlementIndex<TSelectData = EntitlementIndexResponse>(
	organisation: EntitlementIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					EntitlementIndexResponse,
					AxiosError<EntitlementIndexError>,
					TSelectData,
					EntitlementIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<EntitlementIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...entitlementIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/EntitlementController.php EntitlementController::index */
export function useEntitlementIndexSuspense<TSelectData = EntitlementIndexResponse>(
	organisation: EntitlementIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					EntitlementIndexResponse,
					AxiosError<EntitlementIndexError>,
					TSelectData,
					EntitlementIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<EntitlementIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...entitlementIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
